export const HOTEL_UNAVAILABLE_MESSAGE =
  "Desculpe, esta acomodação não está mais disponível para as datas selecionadas. Por favor, escolha outro quarto ou busque um novo hotel para continuar sua viagem.";

export const GENERIC_ERROR_MESSAGE =
  "Ocorreu algum problema, por favor, tente novamente!";

export const PAYMENT_ERROR_MESSAGE =
  "A operadora recusou o pagamento. Verifique os dados do cartão e tente novamente.";

// Mapeia o status HTTP do checkRate de hotel para a ação do checkout:
// { error } exibe mensagem na página; { redirect, bookingError? } navega.
// 422 = sem disponibilidade (ver api-hub HotelServiceType.get) — não adianta tentar de novo.
export const mapHotelCheckRateError = (status, serverError) => {
  switch (status) {
    case 400:
      return { error: "Há algo de errado nos seus dados, verifique!" };
    case 401:
      return { redirect: "/session-expires" };
    case 409:
      return { redirect: "/busca/booking-error", bookingError: serverError };
    case 422:
      return { error: HOTEL_UNAVAILABLE_MESSAGE };
    case 504:
      return {
        redirect: "/busca/booking-error",
        bookingError: "Tempo expirou, tente novamente!",
      };
    default:
      return { error: GENERIC_ERROR_MESSAGE };
  }
};

// Mensagem de erro vinda do api-hub (Strapi): { error: { message, details: { error } } }.
// Regra de negócio (sem vaga, mínimo de passageiros) chega aqui com o texto pronto
// para o cliente — é ele que deve aparecer na tela, não a mensagem genérica.
export const apiErrorMessage = (error, fallback = GENERIC_ERROR_MESSAGE) => {
  const data = error?.response?.data;
  return (
    data?.error?.message ||
    data?.error?.details?.error ||
    data?.message ||
    fallback
  );
};

// 400/409/422 do api-hub são regra de negócio: não adianta seguir, o passo
// seguinte vai falhar igual. Qualquer outra falha (rede, 500) é transitória.
export const isBlockingApiError = (error) =>
  [400, 409, 422].includes(error?.response?.status);

// Verifica se o erro 400 é de pagamento (cartão recusado) ou dados inválidos.
// Retorna a mensagem adequada conforme o tipo de erro.
// REGRA: Sempre exibe mensagem amigável na tela quando for erro de pagamento
// OU quando houver mensagem do servidor (que pode ser técnica).
// A mensagem específica do servidor fica apenas nos logs e e-mails de erro.
export const getCheckoutErrorMessage = (error) => {
  const isPaymentError = error?.response?.data?.error?.isPaymentError;
  const serverMessage = error?.response?.data?.error?.message;

  // Exibe mensagem amigável se for erro de pagamento OU se tiver mensagem do servidor
  if (isPaymentError || (typeof serverMessage === "string" && serverMessage)) {
    return PAYMENT_ERROR_MESSAGE;
  }

  // Mensagem genérica apenas quando não há nenhuma informação específica
  return "Há algo de errado nos seus dados, verifique!";
};
